export default "__VITE_ASSET__bvY66OC1__"